var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHurryIconinline = function SvgHurryIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#AF3535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.111,
    d: "M8.002 16.504a6.846 6.846 0 1 0 0-13.692 6.846 6.846 0 0 0 0 13.692M8.07 9.71l3.423-3.422M12.982 4.813l.745-.745"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AF3535",
    strokeWidth: 1.111,
    d: "M8.07 2.527V1.5M6.5.944h3"
  })));
};
export default SvgHurryIconinline;